import { gql, useMutation, useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { PROFILE } from '../lib/graphql/queries/customer';
import {LOGOUT} from '../lib/graphql/mutations/customer';

export function useAuth({ redirectToLogin = false } = {}) {
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem('token'));

  const { data, loading, error, refetch } = useQuery(PROFILE, {
    fetchPolicy: 'cache-and-network',
    skip: !token, // Skip query if no token
  });


  const [logout] = useMutation(LOGOUT, {
    refetchQueries: ["Profile"],
    onCompleted: () => {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      setToken(null);
      navigate("/");
    },
    onError: (error) => {
      console.error("Logout failed:", error);
    },
  });

  const user = data?.profile || null;

  // Listen for token changes in localStorage
  useEffect(() => {
    const handleStorageChange = () => {
      const newToken = localStorage.getItem('token');
      if (newToken !== token) {
        setToken(newToken);
        if (newToken) {
          refetch(); // Refetch user data when token is added
        }
      }
    };

    // Listen for custom events that might be dispatched on login
    const handleAuthChange = () => {
      const newToken = localStorage.getItem('token');
      if (newToken && newToken !== token) {
        setToken(newToken);
        refetch();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('authTokenChanged', handleAuthChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('authTokenChanged', handleAuthChange);
    };
  }, [token, refetch]);

  useEffect(() => {
    if (!loading && !user && redirectToLogin) {
      navigate('/auth');
    }
  }, [loading, user, redirectToLogin, navigate]);

  return { user, loading, error, refetch, logout };
}
